import { AjaxModule, TabulatorFull } from 'tabulator-tables'

// Tabulator 6.3.1 defers creation and reports rejected loads after destroy().
// Keep those callbacks from rebuilding or changing a reconnected directory.
// The brand's flight path with its paper plane (see InkFlightHelper), shown
// while rows load. Static markup; the words stay for screen readers.
const LOADING_MARK =
  '<span class="ink-flight ink-flight--trail" aria-hidden="true"><span class="ink-flight__plane">' +
  '<svg viewBox="-1.5 -1.5 15 13" focusable="false"><path class="ink-flight__halo" d="M1 1 L11 5 L1 9 Z"/>' +
  '<path class="ink-flight__body" d="M1 1 L11 5 L1 9 L3.4 5 Z"/><path class="ink-flight__fold" d="M3.4 5 L11 5"/></svg>' +
  '</span></span>Loading'

export default class DirectoryTable extends TabulatorFull {
  constructor(element, options) {
    const request = options.ajaxRequestFunc || AjaxModule.defaultLoaderPromise
    const response = options.ajaxResponse
    super(element, {
      dataLoaderLoading: LOADING_MARK,
      ...options,
      ajaxRequestFunc: function(...args) {
        return request.apply(this, args).catch(error => {
          if (!this.table.destroyed) throw error
          return {}
        })
      },
      ajaxResponse: function(url, params, data) {
        if (this.destroyed) return {}
        return response ? response.call(this, url, params, data) : data
      },
    })
  }

  _create() {
    if (!this.destroyed) super._create()
  }
}
